import { CountUp } from "countup.js";
import { debounce } from "lodash";

let counterHumAid;
let counterDonations;
let counterDevileries;
const humAidEl = document.getElementById("humAid");
const donationsEl = document.getElementById("donations");
const deliveriesEl = document.getElementById("deliveries");

(function() {
  if(humAidEl) {
    counterHumAid = new CountUp("humAid", humAidEl.dataset.counterValue, {
      suffix: " Tons"
    });
  }
  if(donationsEl) {
    counterDonations = new CountUp("donations", donationsEl.dataset.counterValue, {
      suffix: "K+"
    });
  }
  if(deliveriesEl) {
    counterDevileries = new CountUp("deliveries", deliveriesEl.dataset.counterValue, {
      suffix: "+"
    });
  }
}());

function updateCounters() {
  //To sync with AOS fade-in animations
  setTimeout(() => {
    if (isElementInViewport(humAidEl)) {
      if (!counterHumAid.error) {
        counterHumAid.start();
      } else {
        console.error(counterHumAid.error);
      }
    }

    if (isElementInViewport(donationsEl)) {
      if (!counterDonations.error) {
        counterDonations.start();
      } else {
        console.error(counterDonations.error);
      }
    }

    if (isElementInViewport(deliveriesEl)) {
      if (!counterDevileries.error) {
        counterDevileries.start();
      } else {
        console.error(counterDevileries.error);
      }
    }
  }, 700);
}

window.addEventListener("scroll", debounce(updateCounters, 30));
updateCounters();
